import { render, staticRenderFns } from "./ApplicationsRecommendation.vue?vue&type=template&id=7fbee50e&scoped=true&"
import script from "./ApplicationsRecommendation.vue?vue&type=script&lang=js&"
export * from "./ApplicationsRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationsRecommendation.vue?vue&type=style&index=0&id=7fbee50e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbee50e",
  null
  
)

export default component.exports